import {
  FileInput,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
} from "react-admin";
import { MobileApplicationType } from "../../../common/data/service-proxies";
import { UploadedFileField } from "../../common/form/UploadedFileField";

interface Props {}

export const MobileAppVersionForm = (props: Props) => {
  return (
    <SimpleForm className="form-create-edit" variant="outlined" {...props}>
      <SelectInput
        validate={required()}
        source="mobileApplicationTypeString"
        label="Operating system"
        choices={[
          { id: MobileApplicationType.Android, name: "Android" },
          { id: MobileApplicationType.AppleIos, name: "iOS" },
        ]}
      />
      <TextInput
        validate={required()}
        source="appVersion"
        label="App version"
      />
      <NumberInput
        validate={required()}
        source="buildNumber"
        label="Build number"
      />
      <FileInput validate={required()} source="file" label="Installer file">
        <UploadedFileField source="src" uploadStatus="uploaded" />
      </FileInput>
    </SimpleForm>
  );
};
